/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * An enumeration.
 */
export enum AddressTypeEnum {
  BILLING = "BILLING",
  SHIPPING = "SHIPPING",
}

/**
 * An enumeration.
 */
export enum AuthorizationKeyType {
  APPLE_ID = "APPLE_ID",
  FACEBOOK = "FACEBOOK",
  FACEBOOK_LIMITED_LOGIN = "FACEBOOK_LIMITED_LOGIN",
  GOOGLE_OAUTH2 = "GOOGLE_OAUTH2",
}

/**
 * An enumeration.
 */
export enum CartPaymentType {
  CASHFREE = "CASHFREE",
  COD = "COD",
  PREPAID = "PREPAID",
  SIMPL = "SIMPL",
  TAZAPAY_CARD = "TAZAPAY_CARD",
}

/**
 * An enumeration.
 */
export enum DisplayMenuType {
  BRAND = "BRAND",
  CATEGORY_1 = "CATEGORY_1",
  CATEGORY_2 = "CATEGORY_2",
  COLLECTION = "COLLECTION",
  TAG = "TAG",
}

/**
 * An enumeration.
 */
export enum EventTypeEnum {
  CANCEL = "CANCEL",
  DEDUCT = "DEDUCT",
  EARN = "EARN",
  EXPIRE = "EXPIRE",
  REVOKE = "REVOKE",
}

/**
 * An enumeration.
 */
export enum ExhibitionSectionType {
  COLLECTION = "COLLECTION",
  PRODUCT = "PRODUCT",
}

/**
 * An enumeration.
 */
export enum FulfillmentStatus {
  CANCELED = "CANCELED",
  DAMAGED = "DAMAGED",
  DELIVERED = "DELIVERED",
  FULFILLED = "FULFILLED",
  LOST = "LOST",
  RETURNED = "RETURNED",
  RETURN_IN_TRANSIT = "RETURN_IN_TRANSIT",
}

/**
 * An enumeration.
 */
export enum GenderChoiceEnum {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
}

/**
 * An enumeration.
 */
export enum IndustryChoiceEnum {
  AGRICULTURE_AND_ALLIED_INDUSTRIES = "AGRICULTURE_AND_ALLIED_INDUSTRIES",
  AUTOMOBILES = "AUTOMOBILES",
  AUTO_COMPONENTS = "AUTO_COMPONENTS",
  AVIATION = "AVIATION",
  BANKING = "BANKING",
  BEAUTY = "BEAUTY",
  CEMENT = "CEMENT",
  CONSUMER_DURABLES = "CONSUMER_DURABLES",
  ECOMMERCE = "ECOMMERCE",
  EDUCATION_AND_TRAINING = "EDUCATION_AND_TRAINING",
  ENGINEERING_AND_CAPITAL_GOODS = "ENGINEERING_AND_CAPITAL_GOODS",
  FINANCIAL_SERVICES = "FINANCIAL_SERVICES",
  FMCG = "FMCG",
  GEMS_AND_JEWELLERY = "GEMS_AND_JEWELLERY",
  HEALTHCARE = "HEALTHCARE",
  INFRASTRUCTURE = "INFRASTRUCTURE",
  INSURANCE = "INSURANCE",
  IT_AND_ITES = "IT_AND_ITES",
  MANUFACTURING = "MANUFACTURING",
  MEDIA_AND_ENTERTAINMENT = "MEDIA_AND_ENTERTAINMENT",
  METALS_AND_MINING = "METALS_AND_MINING",
  NOT_OCCUPIED = "NOT_OCCUPIED",
  OIL_AND_GAS = "OIL_AND_GAS",
  OTHER = "OTHER",
  PHARMACEUTICALS = "PHARMACEUTICALS",
  PORTS = "PORTS",
  POWER = "POWER",
  RAILWAYS = "RAILWAYS",
  REAL_ESTATE = "REAL_ESTATE",
  RENEWABLE_ENERGY = "RENEWABLE_ENERGY",
  RETAIL = "RETAIL",
  ROADS = "ROADS",
  SCIENCE_AND_TECHNOLOGY = "SCIENCE_AND_TECHNOLOGY",
  SERVICES = "SERVICES",
  STEEL = "STEEL",
  TELECOMMUNICATIONS = "TELECOMMUNICATIONS",
  TEXTILES = "TEXTILES",
  TOURISM_AND_HOSPITALITY = "TOURISM_AND_HOSPITALITY",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * An enumeration.
 */
export enum OrderPaymentType {
  CASHFREE = "CASHFREE",
  COD = "COD",
  PREPAID = "PREPAID",
  SIMPL = "SIMPL",
  TAZAPAY_CARD = "TAZAPAY_CARD",
}

/**
 * An enumeration.
 */
export enum OrderStatus {
  CANCELED = "CANCELED",
  CUSTOM_CLEARANCE_IN_PROGRESS = "CUSTOM_CLEARANCE_IN_PROGRESS",
  DAMAGED = "DAMAGED",
  DELIVERED = "DELIVERED",
  DISPATCHED_TO_INDIA = "DISPATCHED_TO_INDIA",
  DRAFT = "DRAFT",
  FULFILLED = "FULFILLED",
  LOST = "LOST",
  PACKED_BY_BRAND_IN_KOREA = "PACKED_BY_BRAND_IN_KOREA",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  PENDING_REVIEW = "PENDING_REVIEW",
  PREPARING_MGS_ORDER = "PREPARING_MGS_ORDER",
  RETURNED = "RETURNED",
  UNFULFILLED = "UNFULFILLED",
  WAITING_FOR_PICKUP = "WAITING_FOR_PICKUP",
}

export enum OrderStatusFilter {
  READY_TO_CAPTURE = "READY_TO_CAPTURE",
  READY_TO_FULFILL = "READY_TO_FULFILL",
}

/**
 * An enumeration.
 */
export enum OtpStatus {
  CREATED = "CREATED",
  OTPSTATUS_CREATED = "OTPSTATUS_CREATED",
  OTPSTATUS_SENT = "OTPSTATUS_SENT",
  OTPSTATUS_VERIFIED = "OTPSTATUS_VERIFIED",
  SENT = "SENT",
  VERIFIED = "VERIFIED",
}

/**
 * An enumeration.
 */
export enum PaymentChargeStatusEnum {
  CHARGED = "CHARGED",
  FULLY_REFUNDED = "FULLY_REFUNDED",
  NOT_CHARGED = "NOT_CHARGED",
}

/**
 * An enumeration.
 */
export enum PaymentTypeEnum {
  CASHFREE = "CASHFREE",
  COD = "COD",
  PREPAID = "PREPAID",
  SIMPL = "SIMPL",
  TAZAPAY_CARD = "TAZAPAY_CARD",
}

export enum ProductOrderField {
  DATE = "DATE",
  NAME = "NAME",
  POPULARITY = "POPULARITY",
  PRICE = "PRICE",
  RANKING = "RANKING",
  REVIEW_RATING = "REVIEW_RATING",
}

/**
 * An enumeration.
 */
export enum ProductReviewStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  SPAM = "SPAM",
}

export enum ReviewSortField {
  CREATE_AT = "CREATE_AT",
  RATING = "RATING",
  TOTAL_VOTES = "TOTAL_VOTES",
}

/**
 * An enumeration.
 */
export enum StateChoiceEnum {
  ANDAMAN_AND_NICOBAR_ISLANDS = "ANDAMAN_AND_NICOBAR_ISLANDS",
  ANDHRA_PRADESH = "ANDHRA_PRADESH",
  ARUNACHAL_PRADESH = "ARUNACHAL_PRADESH",
  ASSAM = "ASSAM",
  BIHAR = "BIHAR",
  CHANDIGARH = "CHANDIGARH",
  CHHATTISGARH = "CHHATTISGARH",
  DADRA_AND_NAGAR_HAVELI = "DADRA_AND_NAGAR_HAVELI",
  DAMAN_AND_DIU = "DAMAN_AND_DIU",
  DELHI = "DELHI",
  GOA = "GOA",
  GUJARAT = "GUJARAT",
  HARYANA = "HARYANA",
  HIMACHAL_PRADESH = "HIMACHAL_PRADESH",
  JAMMU_AND_KASHMIR = "JAMMU_AND_KASHMIR",
  JHARKHAND = "JHARKHAND",
  KARNATAKA = "KARNATAKA",
  KERALA = "KERALA",
  LAKSHADWEEP = "LAKSHADWEEP",
  MADHYA_PRADESH = "MADHYA_PRADESH",
  MAHARASHTRA = "MAHARASHTRA",
  MANIPUR = "MANIPUR",
  MEGHALAYA = "MEGHALAYA",
  MIZORAM = "MIZORAM",
  NAGALAND = "NAGALAND",
  ODISHA = "ODISHA",
  PUDUCHERRY = "PUDUCHERRY",
  PUNJAB = "PUNJAB",
  RAJASTHAN = "RAJASTHAN",
  SIKKIM = "SIKKIM",
  TAMIL_NADU = "TAMIL_NADU",
  TELANGANA = "TELANGANA",
  TRIPURA = "TRIPURA",
  UTTARAKHAND = "UTTARAKHAND",
  UTTAR_PRADESH = "UTTAR_PRADESH",
  WEST_BENGAL = "WEST_BENGAL",
}

export enum StockAvailability {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
}

/**
 * An enumeration.
 */
export enum TransactionKind {
  AUTH = "AUTH",
  CAPTURE = "CAPTURE",
  CHARGE = "CHARGE",
  INIT = "INIT",
  REFUND = "REFUND",
  VOID = "VOID",
}

/**
 * An enumeration.
 */
export enum VoucherDiscountValueType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}

/**
 * An enumeration.
 */
export enum VoucherType {
  BRAND = "BRAND",
  CATEGORY = "CATEGORY",
  COLLECTION = "COLLECTION",
  PRODUCT = "PRODUCT",
  SHIPPING = "SHIPPING",
  VALUE = "VALUE",
}

export interface AddressInput {
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  cityArea?: string | null;
  postalCode?: string | null;
  country: string;
  countryArea?: string | null;
  phone0?: string | null;
  phone1?: string | null;
  addressNickname?: string | null;
}

export interface CartLineBulkUpdateInput {
  lineId: string;
  quantity?: number | null;
  selected?: boolean | null;
}

export interface CartLineInput {
  quantity: number;
  variantId: string;
}

export interface CheckoutCreateInput {
  lines: (CheckoutLineInput | null)[];
  forMgs?: boolean | null;
}

export interface CheckoutLineInput {
  quantity: number;
  variantId: string;
}

export interface CheckoutUpdateInput {
  voucherCode?: string | null;
  note?: string | null;
  usedPoint?: number | null;
  shippingAddress?: AddressInput | null;
  shippingAddressId?: string | null;
  paymentType?: PaymentTypeEnum | null;
}

export interface CustomerChangePasswordInput {
  oldPassword: string;
  newPassword: string;
}

export interface CustomerDeleteConfirmInput {
  token: any;
}

export interface CustomerPasswordResetInput {
  email: string;
}

export interface CustomerSignUpInput {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  otpId: string;
  otpValue: string;
  referralCode?: string | null;
  cartToken?: any | null;
  mobileNumber: string;
  birthday?: any | null;
}

export interface CustomerUpdateInput {
  firstName?: string | null;
  lastName?: string | null;
  note?: string | null;
  mobileNumber?: number | null;
  birthday?: any | null;
  gender?: GenderChoiceEnum | null;
  state?: StateChoiceEnum | null;
  city?: string | null;
  industry?: IndustryChoiceEnum | null;
  skinType?: string | null;
  skinConcern?: string | null;
  nickname?: string | null;
  instagram?: string | null;
  youtube?: string | null;
  blog?: string | null;
  bio?: string | null;
}

export interface DeleteCartLineInput {
  cartId: string;
  lineId: string;
}

export interface OtpInput {
  receiver?: string | null;
}

export interface PointCampaignEventInput {
  campaign: string;
}

export interface ProductOrder {
  field: ProductOrderField;
  direction: OrderDirection;
}

export interface ReviewImagesCreateInput {
  images: (any | null)[];
  review: string;
}

export interface ReviewInput {
  product?: string | null;
  rating?: number | null;
  title?: string | null;
  comment?: string | null;
  variant?: string | null;
}

export interface ReviewOrder {
  field: ReviewSortField;
  direction: OrderDirection;
}

export interface SetPasswordInput {
  token: string;
  password: string;
}

export interface VerifyEmailInput {
  token: string;
}

export interface VerifyOtpInput {
  receiver: string;
  value: string;
}

export interface VoteCreateInput {
  review: string;
  voter: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
